import { render, staticRenderFns } from "./success-box.vue?vue&type=template&id=8b835d02&"
import script from "./success-box.vue?vue&type=script&lang=js&"
export * from "./success-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports